export default __webpack_public_path__ + "static/media/2248.f4574a4b.png";